import React from "react";
import { Typography, Flex } from "antd";
import { CustomTable } from "../utils/CustomComponents";
const { Text, Title } = Typography;

const PouredType = ({ loads, history }) => {
	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Delivery Ticket",
			dataIndex: "deliveryTicket",
			key: "deliveryTicket",
			render: (value, record) => {
				return (
					<Text
						strong
						onClick={() => history.push(`/pouring/job/load/${record.id}`)}
						style={{ cursor: "pointer" }}
					>
						{value}
					</Text>
				);
			},
		},
		{
			title: "Driver",
			dataIndex: "driver",
			key: "driver",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Truck Number",
			dataIndex: "truckNumber",
			key: "truckNumber",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Slump",
			dataIndex: "plantSlump",
			key: "plantSlump",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Temperature",
			dataIndex: "plantTemperature",
			key: "plantTemperature",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Load Time",
			dataIndex: "date",
			key: "date",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Departure",
			dataIndex: "departure",
			key: "departure",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Slump",
			dataIndex: "jobSiteSlump",
			key: "jobSiteSlump",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Temperature",
			dataIndex: "jobSiteTemperature",
			key: "jobSiteTemperature",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Drum Rotation",
			dataIndex: "jobSiteDrumRotation",
			key: "jobSiteDrumRotation",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Recomended Time to Unload",
			dataIndex: "toJobDate",
			key: "toJobDate",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Ambient Temperature",
			dataIndex: "jobSiteAmbientTemperature",
			key: "jobSiteAmbientTemperature",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
	];

	return (
		<Flex gap={"middle"} vertical>
			<Title level={1}>Poured Loads</Title>
			<CustomTable columns={columns} data={loads} />
		</Flex>
	);
};

export default PouredType;
